export const ADD_PARTICIPANT_BODY = "@add-participant-body";
export const SEND_EMAIL_CONFIRMATION_DATA = "@send-email-confirmation-data";
export const TOTAL_PRICE = "@total-price";
export const BOOK_SERVICE_BODY = "@book-service-body";
export const REDUX_STATE = "@redux-state";
export const IDEAL_BANK_NAMES = {
  abn_amro: "ABN AMRO",
  asn_bank: "ASN Bank",
  bunq: "Bunq",
  handelsbanken: "Handelsbanken",
  ing: "ING",
  knab: "Knab",
  rabobank: "Rabobank",
  revolut: "Revolut",
  regiobank: "RegioBank",
  sns_bank: "SNS Bank (De Volksbank)",
  triodos_bank: "Triodos Bank",
  van_lanschot: "Van Lanschot",
};
export const BOOKING_ID = "@booking-id";
export const STRIPE_AC_ID = "@stripe-ac-id";
export const ALL_SERVICE_SELECTED_IDX = "@all-service-selected-idx";
export const SERVICE_ID = "@service-id";
export const SLOT_ID = "@slot-id";
export const BOOKINK_LINK = "@bookink-link";
export const BOOKINK_EVENT_NAME = "@bookink-event-name";
export const BOOKINK_EVENT_REFERENCE = "@bookink-event-reference";
export const BOOKINK_SESSION= "@bookink-session";
export const BOOKINK_CART = "@bookink-cart";
export const SELLER_REF = "@seller-ref";
export const CAMPAIGN_REF = "@campaign-ref";
export const TRACK_TOKEN = "@track-token";
export const USER = {
  FULLNAME: "@user-fullName",
  EMAIL: "@user-email",
  USERNAME: "@user-username",
};

export const API_URL = `https://api.tikitly.com/${(process.env.REACT_APP_ENVIRONMENT && process.env?.REACT_APP_ENVIRONMENT.toLowerCase()) === "prod" ? "prod" : "dev"}`;

// const environment = process.env.REACT_APP_ENVIRONMENT;
// export const BASE_URL = "https://bmcapi-dev.bookzy.app/dev";
// export const BASE_URL =
//   environment === "PROD" ? API_URL + "/prod" : API_URL + "/dev";
// export const BASE_URL = API_URL + "/evnts";
export const BASE_URL = API_URL;
